// extracted by mini-css-extract-plugin
export var audioPlayer = "_of-0";